import React from "react";

const bootstrapIconMap = {
  Instagram: "bi-instagram",
  Facebook: "bi-facebook",
  TikTok: "bi-tiktok",
  YouTube: "bi-youtube",
  Spotify: "bi-spotify",
  SoundCloud: "bi-cloud-fog2-fill",
  Twitter: "bi-twitter-x",
};

export default function SocialPlatforms({
  platforms = [],
  userHasAnyUrl = false,
  variant = "modern", // modern | base | advance
}) {
  if (!platforms?.length) return null;

  const containerStyles = {
    modern: "flex flex-wrap justify-center gap-3",
    base: "flex flex-wrap justify-center gap-3",
    advance: "flex flex-wrap justify-center gap-3",
  };

  const linkStyles = {
    modern: "text-gray-300 hover:text-white transition-colors",
    base: "bg-white h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors",
    advance:
      "bg-white h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors",
  };

  const iconStyles = {
    modern: "text-lg",
    base: "text-base",
    advance: "text-base",
  };

  return (
    <div className={containerStyles[variant]}>
      {platforms
        .filter((p) => (userHasAnyUrl ? p.url : true))
        .map((p) => {
          const bootstrapIcon = bootstrapIconMap[p.name];

          return (
            <a
              key={p.id}
              href={p.url || "#"}
              target="_blank"
              rel="noreferrer"
              className={linkStyles[variant]}
            >
              {bootstrapIcon ? (
                <i className={`bi ${bootstrapIcon} ${iconStyles[variant]}`} />
              ) : (
                <img src={p.icon} alt={p.name} className="w-[18px]" />
              )}
            </a>
          );
        })}
    </div>
  );
}
// export default SocialPlatforms;